import PropTypes from 'prop-types';

import { formatShipByDate } from 'common/utils';

const ShipByDateCell = ({ shipByDate, onClick }) => {
  const formatted = formatShipByDate(shipByDate);
  if (onClick) {
    return (
      <button
        type='button'
        onClick={onClick}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          margin: 0,
          cursor: 'pointer',
          textDecoration: 'underline',
          fontFamily: 'inherit',
          fontSize: 'inherit',
          fontWeight: 'inherit',
          lineHeight: 'inherit',
          color: 'inherit',
          display: 'inline',
          appearance: 'none',
        }}
      >
        {formatted}
      </button>
    );
  }
  return <span>{formatted}</span>;
};

ShipByDateCell.propTypes = {
  shipByDate: PropTypes.string,
  onClick: PropTypes.func,
};

ShipByDateCell.defaultProps = {
  shipByDate: undefined,
  onClick: undefined,
};

export default ShipByDateCell;
